"use client";

import React from "react";
import { ArrowRight, Layers } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function Hero() {
  return <section id="hero" data-nav="light" className="relative w-full bg-background text-foreground border-b border-border overflow-hidden">
      {/* Industrial Blueprint Grid Overlay */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.035]" aria-hidden="true">
        <svg className="w-full h-full" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="industrial-grid" width="48" height="48" patternUnits="userSpaceOnUse">
              <path d="M 48 0 L 0 0 0 48" fill="none" stroke="currentColor" strokeWidth="1" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#industrial-grid)" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          {/* Main Hero Column */}
          <div className="lg:col-span-7 flex flex-col space-y-6">
            {/* Monospace Badge Tag */}
            <div className="flex items-center gap-2">
              <Badge variant="outline" className="font-mono text-xs font-semibold uppercase tracking-wider px-3 py-1 bg-accent/60 text-accent-foreground border-border rounded-none">
                <Layers className="size-3.5 mr-1 text-primary" />
                BULL + INFLATABLE SYSTEMS
              </Badge>
            </div>

            {/* Main Display Heading */}
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight font-bold text-foreground leading-[1.05]">
              Inflatable Mechanical Bulls for Sale
            </h1>

            {/* Industrial Blueprint Divider */}
            <div className="h-1 w-20 bg-primary" aria-hidden="true" />

            {/* Descriptive Body Copy */}
            <div className="space-y-4 text-base sm:text-lg text-foreground/90 font-sans leading-relaxed">
              <p>
                An inflatable mechanical bull combines a powered mechanical bull with an inflatable safety arena designed around the ride. If you're comparing an inflatable mechanical bull for sale, look at the bull, controller, inflatable, blower, package contents and setup requirements separately before deciding which system fits your operation.
              </p>
              <p className="text-muted-foreground text-sm sm:text-base">
                You may also see these systems described as a mechanical bull inflatable or inflatable rodeo bull. Whatever terminology a seller uses, confirm that the listing describes a powered mechanical bull system and exactly which inflatable components are included.
              </p>
            </div>

            {/* Call to Actions */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-4">
              <Button asChild size="lg" className="rounded-none font-mono uppercase text-xs tracking-wider font-semibold bg-primary text-primary-foreground hover:bg-primary/90 shadow-none px-6 py-6">
                
              </Button>

              <Button asChild size="lg" className="rounded-none font-mono uppercase text-xs tracking-wider font-semibold bg-primary text-primary-foreground hover:bg-primary/90 shadow-none px-6 py-6">
                <Link to="/RequestQuotePage">
                  <span>REQUEST A QUOTE</span>
                </Link>
              </Button>
            </div>
          </div>

          {/* Blueprint Side Card / Systems Overview */}
          <div className="lg:col-span-5 flex flex-col space-y-4">
            
          </div>
        </div>
      </div>
    </section>;
}